export { DynamicTag } from "./dynamic-tag.component";
